// extracted by mini-css-extract-plugin
export var gallery = "Gallery-module--gallery--TGBH+";
export var galleryItem = "Gallery-module--gallery-item--VRzpP";
export var gallery__imageWrapper = "Gallery-module--gallery__image-wrapper--OgN3R";
export var gallery__image = "Gallery-module--gallery__image--uheVd";